import { useQuery } from '@tanstack/react-query';
import { api } from './client';
export function useJobs(filter, { live = false, enabled = true } = {}) {
    const params = new URLSearchParams();
    if (filter.tab)
        params.set('tab', filter.tab);
    return useQuery({
        queryKey: ['jobs', filter],
        queryFn: () => api(`/jobs?${params}`),
        // `enabled` lets the sidebar skip the poll entirely when the backup service
        // isn't in view — otherwise the running-count badge query hammers the
        // backup backend (500s in dev where it isn't running).
        enabled,
        // `live` is set by the /jobs page autoRefresh toggle. Off elsewhere
        // (e.g. the sidebar running-count badge polls when live=true). Background
        // tabs are paused regardless so a forgotten tab doesn't keep tapping us.
        refetchInterval: live ? 5_000 : false,
        refetchIntervalInBackground: false,
    });
}
export function useJob(id) {
    return useQuery({
        queryKey: ['jobs', id],
        queryFn: () => api(`/jobs/${id}`),
        enabled: !!id,
        refetchInterval: 10_000,
        refetchIntervalInBackground: false,
    });
}
